import { PrivilegesEventsCb, SignalRService, TApartmentCalendarEvent } from '@simOn/utils/signalR';
import { Subject, takeUntil } from 'rxjs';

export function calendarEventListener(signalR: SignalRService, payloadFn: Partial<PrivilegesEventsCb>): () => void {
  const destroy = new Subject<void>();

  signalR
    .listenOnEvent<TApartmentCalendarEvent>('EventCreated')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, eventId }) => {
      payloadFn.EventCreated!({ apartmentId, eventId });
    });

  signalR
    .listenOnEvent<TApartmentCalendarEvent>('EventModified')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, eventId }) => {
      payloadFn.EventModified!({ apartmentId, eventId });
    });

  signalR
    .listenOnEvent<TApartmentCalendarEvent>('EventDeleted')
    .pipe(takeUntil(destroy))
    .subscribe(({ apartmentId, eventId }) => {
      payloadFn.EventDeleted!({ apartmentId, eventId });
    });

  return () => destroy.next();
}
